export default "__VITE_ASSET__CfILjuDM__"